module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1223.3c01f68f.png";